export enum RightLevel {
    NONE = 1,
    READONLY = 2,
    READWRITE = 3
}
